exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formControl[data-v-5813858e]{width:120px;border:1px solid #c5c5c4;border-radius:6px;background:#fff;height:44px;padding:14px 12px;font-size:15px;line-height:1}.formControl[data-error=true][data-v-5813858e]{border:1px solid #eb2000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5813858e","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/uFes/components/FormInputFes.vue
// module id = LJz7
// module chunks = 0